import React from 'react';

const SectionTitle = ({ subtitle, title, align = 'center', className = '' }) => {
  const alignClass = {
    center: 'text-center',
    left: 'text-left',
    right: 'text-right'
  };

  return (
    <div className={`section-title mb-12 ${alignClass[align]} ${className}`}>
      {subtitle && (
        <span className="text-blue-600 font-medium mb-2 block">{subtitle}</span>
      )}
      {title && (
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800">{title}</h2>
      )}
    </div>
  );
};

export default SectionTitle;